import type { CanActivateFn } from '@angular/router';

import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserNotConnectedError } from '@errors/UserNotConnectedError';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngrx/store';
import { serviceSuggestionSetId } from '@stores/services/services.selector';
import { userId } from '@wizbii-utils/angular/stores';
import { SuggestionsWebservice } from '@wizbii-utils/angular/webservices';
import { combineLatest } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

export const canAccessOrderTunnelGuard: CanActivateFn = (_route, _state) => {
  const suggestionsWebservice = inject(SuggestionsWebservice);
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([
    store.select(userId).pipe(filter((userId) => !!userId)),
    store.select(serviceSuggestionSetId).pipe(filter((suggestionSetId) => !!suggestionSetId)),
  ]).pipe(
    switchMap(([userId, suggestionSetId]) => {
      if (!userId) {
        throw new UserNotConnectedError();
      }

      if (!suggestionSetId) {
        throw new Error('No suggestion set id');
      }

      return suggestionsWebservice.getSuggestionsV3(suggestionSetId, userId, 'member');
    }),
    map((suggestionsListing) => {
      if (suggestionsListing.eligibleSuggestions.length < 1) {
        throw new Error('No suggestion found');
      }

      const notYetDeposit = suggestionsListing.eligibleSuggestions.filter((suggestion) => !suggestion.alreadyDeposit);

      if (!notYetDeposit.length) {
        throw new Error('No suggestion was found to be deposit');
      }

      return true;
    }),
    catchError(() => router.navigate(['/', FeaturesRoutingEnum.Dashboard]))
  );
};
